import React from 'react';
import {
 useDataBuilderV2
} from '../DataBuilderV2Context';
import DashboardWelcomeBanner from './DashboardWelcomeBanner';
import OnboardingChecklist from './OnboardingChecklist';
import DashboardStatCards from './DashboardStatCards';
import DashboardActivityFeed from './DashboardActivityFeed';
import DashboardQuickActions from './DashboardQuickActions';

const DashboardV2: React.FC = () => {
    const {
 loading, isNewApp
} = useDataBuilderV2();

    if (loading) {
        return (
            <div className="flex flex-1 items-center justify-center">
                <span className="text-lg font-semibold text-muted-foreground">Loading dashboard...</span>
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-6">
            <DashboardWelcomeBanner />
            {isNewApp && <OnboardingChecklist />}
            <DashboardQuickActions />
            <DashboardStatCards />
            <DashboardActivityFeed />
        </div>
    );
};

export default DashboardV2;
